import { api } from '../api';
import { h } from '../dom';
import { session, type Screen } from '../session';

export function loginScreen(redirect: string, onDone: () => void): Screen {
  const name = h('input', { name: 'username', autocomplete: 'username', maxlength: 20, required: true, autocapitalize: 'off' });
  const password = h('input', { name: 'password', type: 'password', autocomplete: 'current-password', required: true });
  const regCode = h('input', { name: 'code', autocomplete: 'off', placeholder: 'dostaneš od kamaráda' });
  const regCodeLabel = h('label', { style: { display: 'none' } }, 'Kód pro registraci', regCode);
  const error = h('div', { class: 'error' });
  const loginBtn = h('button', { class: 'primary', type: 'submit', style: { width: '100%' } }, 'Přihlásit');
  const registerBtn = h('button', { type: 'button' }, 'Nový účet');

  async function submit(register: boolean) {
    error.textContent = '';
    loginBtn.disabled = registerBtn.disabled = true;
    try {
      const r = register
        ? await api.register(name.value, password.value, regCode.value.trim() || undefined)
        : await api.login(name.value, password.value);
      session.me = r.user;
      session.look = (await api.me().catch(() => null))?.look ?? null;
      if (location.hash !== `#${redirect}`) location.hash = `#${redirect}`;
      else onDone();
    } catch (e) {
      error.textContent = (e as Error).message;
    } finally {
      loginBtn.disabled = registerBtn.disabled = false;
    }
  }

  registerBtn.addEventListener('click', () => {
    if (!name.reportValidity() || !password.reportValidity()) return;
    // Při vyžadovaném kódu nejdřív ukázat políčko
    if (session.registration === 'code' && regCodeLabel.style.display === 'none') {
      regCodeLabel.style.display = '';
      regCode.focus();
      return;
    }
    submit(true);
  });
  if (session.registration === 'closed') registerBtn.style.display = 'none';

  const form = h(
    'form',
    {
      class: 'card',
      onsubmit: (e: Event) => {
        e.preventDefault();
        submit(false);
      },
    },
    h('div', { class: 'logo', style: { textAlign: 'center' } }, 'TANKY'),
    h('p', { class: 'muted small', style: { margin: '0', textAlign: 'center' } }, 'Tahová dělostřelecká bitva pro kamarády'),
    h('label', {}, 'Přezdívka', name),
    h('label', {}, 'Heslo', password),
    regCodeLabel,
    error,
    h('div', { class: 'row' }, h('div', { class: 'grow' }, loginBtn), registerBtn),
  );

  return { el: h('div', { class: 'login backdrop' }, form), destroy() {} };
}
